import React from "react";
import { FormComponent } from "../../../components/form/DynamicForm";
import BuscarFactura from "../../../components/BuscarFactura";
import { Form, Validators } from "../../../components/form/DynamicFormTs";
import { withRouter } from "react-router-dom";
import Http from "../../../Http";
import EnvioFacturas from "./FacturaClienteFacturas";
import { Button } from "@material-ui/core";
import ACCESS from "../../../ACCESS";

class FacturaCliente extends FormComponent {
  componentDidMount() {
    let buttons = ["Guardar Folio"];
    if (this.props.match.params.id) {
      buttons = [];
    }
    this.FormConfig(
      {
        defaultUrl: "envios-factura/one",
        saveUrl: "envios-factura/save",
        backUrl: "/Cobranza/envio-facturas",
      },
      new Form(
        [
          Form.Field("select", "id_sucursal_destino", "Sucursal Destino", "", [Validators.required], 12, [], [], [], false, buttons.length === 0),
          Form.Field("textarea", "descripcion", "Descripcion", "", [], 12, [], [], [], false, buttons.length === 0),
        ],
        buttons,
        "Envio de Facturas"
      ),
      this.formData
    );
    if (this.props.match.params.id) {
      this.LoadPreds();
    }
    this.setState({ facturas: [], add: false });
  }

  LoadPreds = async (predId = null, callOnChange = true) => {
    let id = predId ? predId : this.props.match.params.id;
    let Res = await Http.get(`envios-factura/one/${id}`);
    if (!Res.error) {
      this.formCliId = Res.data.id_cliente;
      this.setState({ FormData: Form.Patch(this.state.FormData, Res.data, callOnChange), });
      this.setState({ FormData: await this.formData() });
    }
    return Res.data;
  };

  formData = async (form) => {
    if (!form) form = this.state.FormData;
    let newForm = form;
    const Res = await Http.get(`envios-factura/form`);
    if (!Res.error) {
      const { sucursales } = Res.data;
      if (sucursales) {
        newForm = Form.FieldOptions(
          newForm,
          "id_sucursal_destino",
          sucursales,
          "id",
          "sucursal_nombre"
        );
      }
    }
    newForm = Form.ValueChange(newForm, {
      id_cliente: this.clienteChange,
    });

    return newForm;
  };

  onAdddFactura = (factura) => {
    this.setState((state) => {
      if (state.facturas.some((sfactura) => sfactura.id === factura.id)) {
        state.sbOpen = true;
        state.sbMsg = "La factura ya fue seleccionada";
      } else {
        factura.nueva = true;
        state.facturas = [factura, ...state.facturas];
        state.add = true;
      }
      return state;
    });
  };

  onSaveFacturas = async () => {
    const id = this.props.match.params.id;
    const id_cliente = this.formCliId;
    const { facturas } = this.state;

    this.setState({ loading: true });
    const Res = await Http.post(`${this.config.saveUrl}`, { id, id_cliente, facturas });

    if (!Res.error) {
      this.setState({ loading: false, sbMsg: "Guardado", sbOpen: true });
      if (this.props.back) {
        this.props.history.push(`${this.config.backUrl}`);
      }
    } else {
      this.setState({
        loading: false,
        sbMsg: `Error al guardar${Res.errMsg ? `: ${Res.errMsg}` : ""}`,
        sbOpen: true,
      });
    }
  };

  onDelete = (fac) => {
    const { facturas } = this.state;
    let newFacturas = facturas.filter(f => f.id !== fac.id);
    this.setState({
      facturas: newFacturas,
      add: true,
    })
  }

  onDownloadReporte = async () => {
    this.setState({ loading: true });
    const id = this.props.match.params.id;
    const Resp = await Http.get(`envios-factura/reporte-facturas-folio?id=${id}`, true, 'arraybuffer')
    if (!Resp.error) {
      const blob = new Blob([Resp], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
      const a = document.createElement('a');
      const url = URL.createObjectURL(blob)
      a.style.display = 'none';
      a.href = url;
      a.download = `reporte_guias_escaneadas_${id}.xlsx`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    } else {
      this.setState({ sbOpen: true, sbMsg: 'Ocurrio un error al generar el archivo' });
    }
    this.setState({ loading: false });
  }

  render() {
    const { match } = this.props;
    const { facturas, add, loading } = this.state;
    const { hasAccess } = this.context;
    return (
      <div>
        <this.FormRender />
        {match.params.id ? (
          <div>
            <BuscarFactura
              idCliente={this.formCliId}
              onSelect={this.onAdddFactura}
            />
            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: '5px' }}>
              {
                hasAccess(ACCESS.COBRANZA_ENVIO_FACTURAS.CREAR_FOLIO) &&
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  onClick={this.onDownloadReporte}
                  disabled={loading}
                  style={{ marginInline: 20 }}
                >
                  Descargar Reporte
                </Button>
              }
              {
                hasAccess(ACCESS.COBRANZA_ENVIO_FACTURAS.CREAR_FOLIO) &&
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  onClick={this.onSaveFacturas}
                  disabled={loading}
                >
                  Guardar
                </Button>
              }
            </div>
            <EnvioFacturas
              idFolio={match.params.id}
              facturas={facturas}
              add={add}
              onAdd={() => {
                this.setState({ add: false });
              }}
              onDelete={this.onDelete}
            />
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

export default withRouter(FacturaCliente);
